import React from "react";
import { Box, TextField, InputAdornment } from "@mui/material";
import { BiSearch } from "react-icons/bi";

/**
 * SearchBar
 *
 * Props:
 * - value: string
 * - setValue: (v: string) => void
 */
const SearchBar = ({ value, setValue, placeholder }) => {
  return (
    <Box sx={{ width: "100%", ml: 1, pr:2 }}>
      <TextField
        fullWidth
        size="small"
        variant="outlined"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        sx={{fieldset: { borderColor: "#888888", mr:2 },
            "& .MuiAutocomplete-endAdornment .MuiIconButton-root": {
                mr: 2
            },
        }} 
        slotProps={{
          input: { 
                sx: {
                fontSize: "0.875rem",
                color: '#555555',
                },
            startAdornment: (
              <InputAdornment position="start">
                <BiSearch size={20} />
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
}

export default SearchBar;